export const PERIODS = [3, 6, 9, 12, 14];
export const PERIODS_WITH_LABEL = [
  { label: '14 months', value: 14 },
  { label: '12 months', value: 12 },
  { label: '9 months', value: 9 },
  { label: '6 months', value: 6 },
  { label: '3 months', value: 3 },
];

export const RANK_COLOR_MODIFIERS = ['', '#D1810114', '#005DB814', '#6F429014'];

export const RANK_FONT_COLOR_MODIFIERS = ['', '#D18101', '#005DB8', '#6F4290'];
